module.exports = __webpack_public_path__ + "static/media/icon_101.a4f9acd4.svg";